<template>
  <ion-page>    
      <ion-header>
        <ion-toolbar>
          <ion-title >
            <ion-grid>
                <ion-row>
                    <ion-col v-if="!isMobile">
                        <ion-button @click="makeLogout()" class="ion-float-left ion-margin-top header-button">
                            <ion-icon :icon="logOutOutline"/>
                            Desconectarse                            
                        </ion-button>
                    </ion-col>
                    <ion-col>
                        <img src="@/assets/logo.png" alt="logo" width="130" class="ion-float-right" />
                    </ion-col>
                </ion-row>
            </ion-grid>
          </ion-title>
        </ion-toolbar>        
      </ion-header>
    <ion-content>

        <ion-row  v-if="isMobile">
            <ion-col>
                <ion-button @click="makeLogout()" class="ion-float-right ion-margin-top header-button">
                    <ion-icon :icon="logOutOutline"/>
                    Desconectarse                            
                </ion-button>
            </ion-col>
        </ion-row>

        <ion-searchbar placeholder="Buscar Rega" @ionInput="search($event)" class="insecal-searchbar" ></ion-searchbar>
        
        <ion-row class="ion-align-items-center">        
            <ion-col v-for="explotacion in explotaciones" :key="explotacion.id" size="12" size-lg="4" >
                <ion-card>
                    <ion-card-content>
                        <ion-card-header>
                            <h2>
                                <font-awesome-icon icon="fa-solid fa-warehouse" />
                                 {{ explotacion.denomina }}
                            </h2>
                        </ion-card-header>
                        <ion-item>
                            <ion-label class="ion-text-wrap">REGA: <br> {{ explotacion.rega }}</ion-label>
                        </ion-item>
                        <ion-item>
                            <ion-label class="ion-text-wrap">UBICACION:<br>{{ explotacion.localidad }} {{ explotacion.provincia?.descrip }}</ion-label>
                        </ion-item>
                        <ion-item>
                            <ion-label class="ion-text-wrap">GANADERO:<br> {{ explotacion.ganadero.denomina }}</ion-label>
                        </ion-item>
                        <ion-button  @click="setExplotacion(explotacion)" > Seleccionar </ion-button>
                    </ion-card-content>              
                </ion-card>
            </ion-col>
        </ion-row>
    </ion-content>
  </ion-page>
</template>

<script lang="ts" setup>

import { 
    IonPage,
    IonContent,
    IonHeader, 
    IonTitle, 
    IonToolbar,
    IonRow,
    IonCol,
    IonCard,
    IonCardContent,
    IonCardHeader,
    IonButton,
    IonItem,
    IonLabel,
    IonSearchbar,
    IonGrid,
    onIonViewWillEnter,
    IonIcon
} from '@ionic/vue';
import { ref  } from 'vue';
import {Explotacion} from '@/models/Explotacion';
import { useExplotacion } from '@/composables/useExplotacion';
import { logOutOutline } from 'ionicons/icons';
import { useUser } from '@/composables/useUser';
import { useNotificacion } from '@/composables/useNotificacion';


const explotacionesCache = ref([] as Array<Explotacion>);

const { listExplotaciones,setExplotacion,explotaciones } = useExplotacion();    
const { makeLogout, isMobile } = useUser();
const { initNotificationConfig } = useNotificacion();

const search = (event:any) => {
    const query = event.target.value;
    if(query === '') {
        explotaciones.value = [...explotacionesCache.value];
    }else {
        explotaciones.value = explotaciones.value.filter((ex) => ex.rega.indexOf(query) > -1 ); 
    }
}

onIonViewWillEnter( async () => {
    await listExplotaciones();
    explotacionesCache.value = explotaciones.value;
    await initNotificationConfig();      
});

</script>

<style scoped>
.header-button {
  --background: #D9534F; /* Rojo apagado */
  --color: #FFFFFF; /* Texto blanco */
  border: none; /* Sin borde */
  border-radius: 5px; /* Bordes redondeados */
  cursor: pointer;
  font-size: 14px;
  font-weight: bold;
  margin-left: auto; /* Alinearlo hacia la derecha */
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); /* Sombra ligera */
  transition: --background 0.3s ease;
}

.header-button:hover {
    --background: #C9302C; /* Rojo más oscuro en hover */
}

ion-searchbar.insecal-searchbar{
    --background: #ffffff;
    --color: #0a0a0a;
    --placeholder-color: #272727;
    --icon-color: #020202;
    --clear-button-color: #050404;
}
:deep(ion-searchbar .searchbar-input-container) {
  min-height: 48px;
  height: 48px;
  display: flex;           /* Para centrar el contenido, si es necesario */
  align-items: center;     /* Centrado vertical */
}
</style>